import { render, staticRenderFns } from "./StaticContentFormInfo.vue?vue&type=template&id=7b331901"
import script from "./StaticContentFormInfo.vue?vue&type=script&lang=js"
export * from "./StaticContentFormInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports